import React, { useEffect, useRef, useState } from "react";
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Card, Row, Col } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import * as RB from "react-bootstrap";
import * as utils from "../../Utils/comman";
import { useSelector } from "react-redux";

function EmployeeGraphView({ rowData, setShowGraph, tabKey }) {
  const navigate = useNavigate();
  const chartRef = useRef(null);
  const chartInstance = useRef(null);
  const [counterExpense, setCounterExpense] = useState({});
  const userProfile = useSelector((state) => state.userProfile.userProfile);

  useEffect(() => {
    if (tabKey === "myCounter" && userProfile?.employeeId) {
      fetchExpenses(userProfile.employeeId);
    } else if (tabKey === "teamCounter" && rowData?.key_person) {
      fetchExpenses(rowData.key_person);
    }
  }, [rowData, tabKey, userProfile?.employeeId]);

  const fetchExpenses = (id) => {
    utils
      .callAPI(
        "get",
        `meeting/counter/view-key-person-wise?key_persion_id=${id}&counter_id=${rowData?.counter_id}`,
      )
      .then((res) => {
        setCounterExpense(res || {});
      })
      .catch(() => {
        setCounterExpense({});
      });
  };

  useEffect(() => {
    if (chartRef.current && counterExpense) {
      const ctx = chartRef.current.getContext("2d");

      if (chartInstance.current) {
        chartInstance.current.destroy();
      }

      const dataValues = [
        parseFloat(counterExpense.gift_amt) || 0,
        parseFloat(counterExpense.meeting_amt) || 0,
        parseFloat(counterExpense.brand_amt) || 0,
        parseFloat(counterExpense.sales_amt) || 0,
      ];

      const colorList = [
        "#757E7F", // gift (SO Pop)
        "#FFDB58", // meeting
        "#F9A8A2", // branding
        "#77B2E8", // sales
      ];

      chartInstance.current = new Chart(ctx, {
        type: "pie",
        data: {
          labels: ["SO Pop", "Meeting", "Branding", "Sales"],
          datasets: [
            {
              label: "Amount",
              data: dataValues,
              backgroundColor: colorList,
              borderColor: "#ffffff",
              borderWidth: 2,
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            datalabels: {
              display: false, // ❌ hides all labels inside chart
            },
            legend: { display: false },
            tooltip: {
              enabled: true,
              callbacks: {
                label: function (tooltipItem) {
                  return `${
                    tooltipItem.label
                  }: ₹${tooltipItem.raw.toLocaleString()}`;
                },
              },
            },
          },
        },
        plugins: [ChartDataLabels],
      });
    }

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [counterExpense]);

  const handleBack = () => {
    setShowGraph(false);
  };

  const handleNavigate = (type) => {
    const id =
      tabKey === "myCounter" ? userProfile?.employeeId : rowData?.key_person;

    if (!id) return;
    navigate(
      `/marketing/employe-counter-detail/${rowData?.counter_id}?type=${type}&keyPerson=${id}&tabKey=${tabKey}`,
    );
  };

  // ✅ Colors synced with chart
  const colorMap = {
    gift: "#003f7d",
    meeting: "#f58220",
    branding: "#50579c",
    sales: "#28a745",
  };

  return (
    <div className="section-body">
      <RB.Card className="card shadow">
        <RB.Card.Header className="border-0">
          <h5>{rowData?.dealership_name}</h5>
          <div className="card-header-action">
            <Link className="btn btn-underline me-2" onClick={handleBack}>
              Close
            </Link>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <Row>
            {/* Chart Section */}
            <Col
              md={4}
              className="d-flex flex-column justify-content-center align-items-center"
            >
              <div className="w-100 d-flex justify-content-center">
                <canvas ref={chartRef}></canvas>
              </div>
              <p className="text-muted mt-2">
                *Note: Hover over the chart segments to view details
              </p>
            </Col>

            {/* Expense Breakdown */}
            <Col md={5} className="d-flex flex-column">
              <h6 className="fw-bold text-secondary pb-2 border-bottom">
                Expense Break-up
              </h6>

              <p
                onClick={() => handleNavigate("gift")}
                style={{
                  fontSize: "1.1rem",
                  color: "black",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                <span
                  style={{
                    display: "inline-block",
                    width: "14px",
                    height: "14px",
                    backgroundColor: colorMap.gift,
                    marginRight: "8px",
                  }}
                ></span>
                SO Pop Amount = ₹
                {parseFloat(counterExpense?.gift_amt || 0).toLocaleString()}/-
              </p>

              <p
                onClick={() => handleNavigate("meeting")}
                style={{
                  fontSize: "1.1rem",
                  color: "black",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                <span
                  style={{
                    display: "inline-block",
                    width: "14px",
                    height: "14px",
                    backgroundColor: colorMap.meeting,
                    marginRight: "8px",
                  }}
                ></span>
                Meeting Amount = ₹
                {parseFloat(counterExpense?.meeting_amt || 0).toLocaleString()}
                /-
              </p>

              <p
                onClick={() => handleNavigate("branding")}
                style={{
                  fontSize: "1.1rem",
                  color: "black",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                <span
                  style={{
                    display: "inline-block",
                    width: "14px",
                    height: "14px",
                    backgroundColor: colorMap.branding,
                    marginRight: "8px",
                  }}
                ></span>
                Branding Amount = ₹
                {parseFloat(counterExpense?.brand_amt || 0).toLocaleString()}/-
              </p>

              <p
                onClick={() => handleNavigate("sales")}
                style={{
                  fontSize: "1.1rem",
                  color: "black",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                <span
                  style={{
                    display: "inline-block",
                    width: "14px",
                    height: "14px",
                    backgroundColor: colorMap.sales,
                    marginRight: "8px",
                  }}
                ></span>
                Sales Amount = ₹
                {parseFloat(counterExpense?.sales_amt || 0).toLocaleString()}/-
              </p>

              <hr />

              <h5 className="fw-bold">
                Total Marketing Expense = ₹
                {(
                  parseFloat(counterExpense.total_amt || 0) -
                  parseFloat(counterExpense.popup_amt || 0)
                ).toLocaleString()}
                /-
              </h5>

              <h5 className="fw-bold">
                Total Sales = ₹
                {parseFloat(counterExpense.sales_amt || 0).toLocaleString()}/-
              </h5>

              {(() => {
                const percent =
                  parseFloat(counterExpense.total_percent || 0) || 0;
                const formatted = percent.toFixed(2); // ✅ 2 decimal places
                const color = percent >= 3 ? "red" : "green"; // ✅ red/green condition

                return (
                  <h5 className="fw-bold" style={{ color }}>
                    Budget Percentage = {formatted}%
                  </h5>
                );
              })()}
            </Col>
          </Row>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default EmployeeGraphView;
